import { render } from "./addToHomeBtn.vue?vue&type=template&id=b15cc19a"
import script from "./addToHomeBtn.vue?vue&type=script&lang=js"
export * from "./addToHomeBtn.vue?vue&type=script&lang=js"
script.render = render

export default script